export default "__VITE_ASSET__e57af8e0__"